import axios from 'axios';
import { API_URL } from '../config/constants';
import { getToken } from './auth';
import { gzipSync } from 'zlib';

class BaseService {
    constructor(rota) {
        this.rota = rota;
        this.headers = [];
    }
    setHeader(header) {
        this.headers = header;
    }

    async getList(body = { sort: null }, skip = 0, limit = 99999) {
        const res = await axios.post(`${API_URL}${this.rota}/get-list/${skip}/${limit}`, body);
        return res.data;
    }

    async getById(id) {
        const res = await axios.get(`${API_URL}${this.rota}/get/${id}`);
        return res.data;
    }

    async reorder(body) {
        const res = await axios.post(`${API_URL}${this.rota}/reorder`, body);
        return res.data;
    }

    async get(rota) {
        this.setHeader({ "Authorization": getToken() });
        const res = await axios.get(`${API_URL}${rota}`, { headers: this.headers });
        return res.data;
    }

    async put(rota, body) {
        this.setHeader({ "Authorization": getToken() });
        const res = await axios.put(`${API_URL}${rota}`, body, { headers: this.headers });
        return res.data;
    }

    async post(rota, body) {
        this.setHeader({ "Authorization": getToken() });
        const res = await axios.post(`${API_URL}${rota}`, body, { headers: this.headers });
        return res.data;
    }

    async postCompress(rota, body) {
        this.setHeader({ "Authorization": getToken(), "content-type": "application/json" });
        const bodyData = gzipSync(JSON.stringify(body)).toString('hex');

        const res = await axios.post(`${API_URL}${rota}`, {data:bodyData}, { headers: this.headers });
        return res.data;
    }

    async upsert(body, id) {
        this.setHeader({ "Authorization": getToken() });
        let res;
        if (id) {
            res = await axios.put(`${API_URL}${this.rota}/save/${id}`, body, { headers: this.headers });
        } else {
            res = await axios.post(`${API_URL}${this.rota}/save`, body, { headers: this.headers });
        }
        return res.data;
    }
}




export default BaseService;